import { moduleProviderFactory } from "core/providers";
import {
    DressingRuleList,
    DressingRuleEdit,
} from "application/dressing-rule/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.dressing-rule",
                pattern: "/dressing-rules",
                children: [
                    {
                        name: "master.app.main.dressing-rule.list",
                        pattern: "",
                        tabTitle: "Dressing Rules",
                        component: DressingRuleList,
                        data: {
                            title: "Dressing Rules",
                        },
                    },
                ],
            },
            {
                name: "master.app.main.dressing-rule.create",
                pattern: "/create",
                tabTitle: "Create Dressing Rule",
                component: DressingRuleEdit,
                authorization: "coreUserSection.create",
                data: {
                    title: "Create Dressing Rule",
                },
            },
            {
                name: "master.app.main.dressing-rule.edit",
                pattern: "/edit/:id",
                tabTitle: "Edit Dressing Rule",
                component: DressingRuleEdit,
                authorization: "coreUserSection.create",
                data: {
                    title: "Dressing Rule Edit",
                },
            },
        ],
        menu: [
            {
                title: "MENU.MASTER_DATA",
                order: 7,
                icon: "database",
                authorization: "administrationSection.read",
                subMenu: [
                    {
                        title: "Dressing Rules",
                        route: "master.app.main.dressing-rule.list",
                        order: 12,
                        authorization: "administrationSection.read",
                    },
                ],
            },
        ],
    });
})();
